module.exports = __webpack_public_path__ + "static/img/visa.98edc46d.png";